// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"989c257b","532":"09ba39d1","600":"b8502feb","732":"f408005e","744":"f48185d8"}[chunkId] + ".chunk.js";
};